import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ className = '' }) => {
  return (
    <footer className={`bg-gray-50 border-t border-gray-200 py-6 ${className}`} style={{ flexShrink: 0 }}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center space-x-6 text-sm text-gray-600">
          <Link 
            to="/terms-of-use" 
            className="hover:text-blue-600 transition-colors"
          >
            Terms of Use
          </Link>
          <span className="text-gray-300">|</span>
          <Link 
            to="/privacy-policy" 
            className="hover:text-blue-600 transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="text-gray-300">|</span>
          <Link 
            to="/support" 
            className="hover:text-blue-600 transition-colors"
          >
            Support
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
